<div
  [attr.aria-describedby]="uuid()"
  [attr.role]="!!role() ? role() : null"
  [ngClass]="cssClasses()"
  class="p-3 border border-2 rounded"
  data-test="inline-notification"
>
  <div class="row flex-nowrap g-2">
    <div class="col-auto text-center">
      <i [ngClass]="iconClasses()" class="{{ colorScheme().iconColorClass }}" style="font-size: 1.5rem"></i>
    </div>
    <div class="col align-self-center">
      @if (showTitle()) {
        <mwe-headline
          [headlineNodeType]="headingNodeType()"
          cssClass="font-size-16 lh-base fw-bold text-secondary mb-2"
          [text]="titleKey()"
          [textParams]="translateValues()"
          [id]="uuid()"
          data-test="inline-notification-headline"
        />
      }
      @if (infoText()) {
        <p class="mb-0">
          <span data-test="inline-notification-message" [innerHTML]="messageKey() | translate: translateValues() | safeHtml"></span>
          <mwe-info-text-icon
            [infoTextTitle]="infoText().title | translate"
            [infoTextDescription]="infoText().description | translate"
            colorClass=""
          />
        </p>
      }
      @if (!infoText() && messageKey()) {
        <p
          [id]="uuid()"
          class="mb-0"
          [innerHTML]="messageKey() | translate: translateValues() | safeHtml"
          data-test="inline-notification-message"
        ></p>
      }
      @if (messageKeys()) {
        <div class="mb-n3">
          @for (key of messageKeys(); track key) {
            <p [innerHTML]="key | translate: translateValues() | safeHtml"></p>
          }
        </div>
      }
      @if (link()) {
        <p class="mb-0">
          <a
            id="inline-notification-link"
            data-test="inline-notification-link"
            href="#"
            mweClickPreventDefault
            (click)="fireLinkClickEvent()"
            [translate]="link()"
          ></a>
        </p>
      }
      <ng-content />
    </div>
    @if (showCloseButton()) {
      <div class="col-auto">
        <button aria-label="Close" class="btn btn-icon btn-sm btn-neutral" type="button" (click)="onClose()">
          <i class="fas fa-xmark-large" aria-hidden="true"></i>
        </button>
      </div>
    }
  </div>
  @if (ctaLabelKey()) {
    <div class="text-end">
      <mwe-button
        color="blue"
        category="tertiary"
        size="md"
        [prependIconClass]="prependIconClass()"
        [labelKey]="ctaLabelKey()"
        [showSpinner]="isCtaLoading()"
        (click)="onCTAClick.emit()"
      />
    </div>
  }
</div>
